import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss'
import { Text } from '../Text/Text';
import styled from 'styled-components';
import Slider from "react-slick";
import { NavLink } from 'react-router-dom';

import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

const Slide = styled.img`
  display: inline-block;
  width: 100%;
`;

const CarouselContainer = styled.div`
  width: 100%;
  
  @media (min-width: 580px) {
    margin-top: 50px;
    position: fixed;
    width: 250px;
  }
  
  @media (min-width: 1025px) {
    width: 350px;
  }
  
  @media (min-width: 1100px) {
    margin-top: 50px;
    width: 500px;
  }
`;

const StoryContainer = styled.div`
  color: #f9e7cc;
  display: flex;
  flex-wrap: wrap;
  font-size: 18px;
  
  .sidebar-photo {
    height: auto;
    object-fit: cover;
    object-position: top left;
    position: fixed;
    width: calc(100vw - 70%);
    z-index: 1;
    margin: 0 auto;
  
    @media (max-width: 640px) {
      position: relative;
    }
    
     @media (max-width: 650px) {
      grid-template-columns: 1fr;
      margin-top: 50px;
      overflow-y: scroll; /* has to be scroll, not auto */
      -webkit-overflow-scrolling: touch;
      //height: calc(100vh);
  
      &__copy {
        height: 100%;
        padding: 30px;
        margin-bottom: 100px
      }
  
      .sidebar-photo {
        max-width: none;
        max-height: none;
        width: 100%;
        height: auto;
      }
    }
  }
  
  &.inside-chevo {
 
    .story__name {
      font-size: 24px;
      
      @media(min-width: 700px) {
        padding-left: 50px;
        margin-top:50px;
      }
      
      @media(min-width: 1025px) {
        font-size: 28px;
        margin-top: 50px;
      }
    }
    .story__title {
      height: auto;
      line-height: 32px;
      padding-left: 0;
      margin-bottom: 20px;
      
      @media(min-width: 700px) {
        padding-left: 50px;
      }
    }
    
    .story__lede {
      font-size: 24px;
      padding-left: 16px;
      
      @media(min-width: 700px) {
        padding-left: 50px;
        padding-right: 50px;
      }
    }
    
    .story__teaser {    
      font-size: 24px;
        
      @media(min-width: 700px) {
        padding-left: 50px;
        padding-right: 50px;
      }
    }
  }
`;



const StoryBackground = styled.div`
    background-position: bottom right;
    background-repeat: no-repeat;
    background-size: contain;
    bottom: 0;
    position: absolute;
    width: 100%;
    z-index: -1;
`;

const StoryCopy = styled.div`
    height: 500px;
    margin-left: 500px;
    padding-top: 40px;
    line-height: 1.7em;
    
    @media(min-width: 500px) {
        height: 500px;
        margin-left: 250px;
        padding-top: 0;
        line-height: 1.7em;
    }
    
    @media(min-width: 1025px) {
        margin-left: 350px;
    }
    
    @media(min-width: 1100px) {
        margin-left: 500px;
    }
    
    .story__lede {
      margin-bottom: 20px;
      quotes: '\\201c' '\\201d';
      
      padding: 10px 0 0 50px;  
      
      @media(min-width: 1025px) {
          padding: 0 50px 0 50px;
      }
  
      &:before {
        content: open-quote;
        position: relative;
        left: -3px;
        margin-left: -18px;
        font-size: 2em;
        opacity: 0.5;
  
        @media (max-width: 640px) {
          margin-left: -16px;
        }
  
      }
    }
    
    .story__teaser {
      margin-bottom: 30px;
      quotes: '\\201c' '\\201d';
      padding-left: 15px;
  
      &:after {
        content: close-quote;
        position: relative;
        margin-left: 0;
        font-size: 2em;
        line-height: 12px;
        top: 12px;
        opacity: 0.5;
        left: 0;
      }
    }
    
    .story__read-more {
      cursor: pointer;
      background-color: #ab3029;
      color: white;
      padding: 10px;
      margin-left: 50px;
    }

    .story__copy {
      padding: 40px 60px 60px;
      line-height: 1.7em;
    }
    
    .story__title {
      font-size: 22px;
      height: 75px;
      line-height: 74px;
      padding-left: 30px;
      
      @media (min-width: 330px) {
        padding-left: 50px;
      }
      
      @media(min-width: 1100px) {
        height: 100px;
        line-height: 98px;
      }
    }
    
    @media (max-width: 640px) {
      padding: 20px 20px 80px;
      margin-left: 0;
      
      p {
        line-height: 32px;
      }
    }
`;

const StoryBody = styled.div`
    background: #ffdcad;
    height: 100%;
    line-height: 32px;
    padding: 20px 50px 50px 50px;
    z-index: 10;
    margin-left: -20px;
    margin-right: -20px;
    
    @media(min-width: 500px) {
    height: 100%;
      margin-left: 0;
      margin-right: 0;
      p {
        font-size: 20px;
      }
    }

    p {
      margin-top: 0;
    }
`;

const BodyTitle = styled.h1`
    line-height: 1.2em;
    
    @media (max-width: 640px) {
      font-size: 1.4em;
    } 
`;

const Image = styled.img`
    display: block;
    margin: 0 auto;
    width: 90px;
    height: auto;
`;

const SectionLinks = styled.ul`
  list-style-type: none;
  padding: 0;
  margin-top: 40px;
  text-align: center;
  width: 100%;
  
  li {
    display: inline-block;
    line-height: 40px;
    white-space: nowrap;
    margin-right: 20px;
    
    a.is-active-menu {
      border-bottom: none;
      color: #f9e2c0;
      background-color: #9c312a;
      padding: 2px 8px;
    }
  }
`;

const Continue = styled.div`
  color: black;
  text-align: center;
`;

const transitionProperties = {
  transitionName: "fadein",
  transitionAppear: false,
  transitionAppearTimeout: 3000,
  transitionEnterTimeout: 3000,
  transitionLeaveTimeout: 3000,
  transitionEnter: true,
  transitionLeave: true,
  key: 1
};

const StoryComponent = ({ selectedStory, allStories, iconImage, handleClick }) => {
  return (<ReactCSSTransitionGroup { ...transitionProperties } >
    <StoryBody className="story__body">
      { selectedStory.bodyTitle && <BodyTitle>{ selectedStory.bodyTitle }</BodyTitle> }
      <Text color="background" size="large" key="story-body" content={ selectedStory.body } />
      <Continue>
        <SectionLinks>
          { allStories.map((story, index) =>
              <li key={ index }>
                <NavLink onClick={ handleClick } activeClassName='is-active-menu' to={`/${story.section}/${story.path}` }>
                  { story.name ? story.name : story.title }
                </NavLink>
              </li>)
          }
        </SectionLinks>
      </Continue>
    </StoryBody>
    <Image src={ iconImage && iconImage.url } />
  </ReactCSSTransitionGroup>)
};


class Story extends React.Component {
  constructor() {
    super();
    this.state = {
      imageIndex: 0
    };
  }


  changeImage() {
    if (this.state.imageIndex === this.props.sidebarPhotos.length - 1) {
      this.setState({ imageIndex: 0 });
    } else {
      this.setState({ imageIndex: this.state.imageIndex + 1 });
    }
  }


  render() {

    const { selectedStory, sidebarPhotos, showExtended, backgroundImage, handleShowMore,
         allStories, menuHighlight, menuTitle, isMobile, handleClick, sectionName } = this.props;

    const settings = {
      dots: true,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      customPaging: (slider, i) => {
        return <span className="paging--circle" />;
      }
    };

    console.log(selectedStory);

    return (
        <div>
          <StoryBackground className="story__background" style={{backgroundImage: `url(${ backgroundImage && backgroundImage.url })`}}/>
          <ReactCSSTransitionGroup {...transitionProperties} >
            <StoryContainer key="story-container" className={`story ${sectionName}`}>
              <CarouselContainer>
                { sidebarPhotos.length > 0 &&
                <Slider {...settings}>
                  { sidebarPhotos.map((photo, i) => {
                    return <div key={ i } ><Slide src={ photo.url } /></div>
                  })}
                </Slider> }

              </CarouselContainer>
              <StoryCopy>
                { selectedStory.name && <Text tag="h1" color="secondary" size="xLarge" className="story__name" content={selectedStory.name}/> }
                {selectedStory.title &&
                <Text tag="h1" color="secondary" size="large" className="story__title" key="story-title"
                      content={selectedStory.title}/>}
                {selectedStory.lede &&
                <Text emphasis color="secondary" size="large" className="story__lede" key="story-lede"
                      content={selectedStory.lede}/>}
                {selectedStory.teaser &&
                <Text emphasis color="secondary" size="large" className="story__teaser" key="story-teaser"
                      content={selectedStory.teaser}/>}

                {!showExtended && selectedStory.name &&
                <span className="story__read-more" onClick={handleShowMore}>
                  Read {selectedStory.name.split(' ')[0]}'s story
                </span>}
                <div id="extendedStory">
                  {showExtended &&
                  <StoryComponent selectedStory={selectedStory} allStories={allStories} isMobile={isMobile}
                                  menuTitle={menuTitle} menuHighlight={menuHighlight} handleClick={ handleClick }
                  />
                  }
                </div>
              </StoryCopy>
            </StoryContainer>
          </ReactCSSTransitionGroup>
        </div>
    );
  }
}

Story.propTypes = {
  selectedStory: PropTypes.object.isRequired,
  sidebarPhotos: PropTypes.array.isRequired,
  sectionName: PropTypes.string,
  showExtended: PropTypes.bool,
  backgroundImage: PropTypes.object,
  handleShowMore: PropTypes.func
};
Story.defaultProps = {};

export default Story;



// WEBPACK FOOTER //
// ./src/components/Story/Story.js